import NavBar from './NavBar.tsx';

export default NavBar;
